module.exports = __webpack_public_path__ + "static/BlockchainMarketplace-a0bbca37ff0319bc53746c452ce46a4e.png";